import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <>
  <div className="terms-service">
  <Container>
    <Row className="justify-content-center">
      <Col md={10} lg={8}>
        <div className="terms-content mt-4 mb-5 p-4">
          <h1 className="text-center mb-4">🔐 Privacy Policy</h1>
          <p className="version-info text-center mb-4">
            Last updated: March 27, 2025
          </p>

          <p>At Kiwispinworld, we take your privacy seriously. This statement explains how we collect, use, and protect your information when you visit our website.</p>
          <p>👉 Note: Kiwispinworld is a free social casino platform.</p>
          <p>We do not offer gambling, no purchases, and there is no opportunity to win real money or prizes.</p>

          <h2>🧾 1. What information do we collect?</h2>
          <p>We only collect anonymous usage data to improve the user experience. This may include:</p>
          <ul>
            <li>🌐 Browser type and device</li>
            <li>🕒 Time and duration of visit</li>
            <li>📄 Which pages were visited</li>
            <li>📍 Approximate location (based on IP address)</li>
          </ul>
          <p>We do not collect personally identifiable information, such as names, addresses, or payment details.</p>
          <p>We also do not process any financial data, since the service does not involve real money.</p>

          <h2>🍪 2. Use of cookies</h2>
          <p>We use cookies to:</p>
          <ul>
            <li>Understand how visitors use the website</li>
            <li>Improve functionality and user experience</li>
            <li>Measure traffic and performance</li>
          </ul>
          <p>You can control or delete cookies yourself in your browser settings.</p>

          <h2>🧠 3. How do we use data?</h2>
          <p>The data is only used for:</p>
          <ul>
            <li>📊 Statistics and analysis (e.g. Google Analytics)</li>
            <li>🔧 Technical improvement of the website</li>
            <li>🛡️ Protection against abuse and security breaches</li>
          </ul>
          <p>We do not sell or share data with third parties, unless necessary for technical operation (e.g. server hosting).</p>

          <h2>🎰 4. No gambling</h2>
          <p>Kiwispinworld is not an online casino with real money. Our games are:</p>
          <ul>
            <li>🆓 Completely free to play</li>
            <li>💸 Have no possibility for deposits or purchases</li>
            <li>❌ Do not offer winnings in real money or physical prizes</li>
          </ul>
          <p>The service is intended for entertainment and social fun only.</p>

          <h2>🧑‍⚖️ 5. Your rights</h2>
          <p>According to the General Data Protection Regulation (GDPR), you have the right to:</p>
          <ul>
            <li>📝 Access what data we have</li>
            <li>✏️ Correct inaccurate information</li>
            <li>❌ Request deletion of your data ("the right to be forgotten")</li>
            <li>🛑 Restrict or object to certain types of data use</li>
          </ul>
          <p>To exercise these rights, contact us at Kiwispinworld@gmail.com.</p>

          <h2>🧷 6. Data security</h2>
          <p>We use modern security measures to protect information from unauthorized access, changes, or loss.</p>

          <h2>🌍 7. Storage and processing in the EEA</h2>
          <p>All data processing is done in accordance with the EU General Data Protection Regulation (GDPR), and data is stored within the EEA.</p>

          <h2>📬 8. Contact</h2>
          <p>Do you have questions regarding this privacy policy or your data?</p>
          <p>Kiwispinworld AS</p>
          <p>📧 Email: Kiwispinworld@gmail.com</p>
          <p>📍 Dronning Eufemias gate 16, 0191 Oslo, Norway</p>
          <p>📞 Phone: +47 22 83 70 10</p>
        </div>
      </Col>
    </Row>
  </Container>
</div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
